module.exports = "/_next/static/images/69417fec7be045f3c1e32281d64a9ca4-secured-icon.svg";